import { cloneDeep, get } from 'lodash'

const convertDataFields = (
  collection: any[] = [],
  childrenKey = 'children',
  fields: string[] = []
) =>
  Array.isArray(collection)
    ? cloneDeep(collection).map((node, key) => {
        const title =
          node?.name ||
          node?.fullName ||
          node?.refValue ||
          node?.title ||
          node?.content
        const updatedNode: any = {
          title,
          label: title,
          value: get(node, ['uuid'], get(node, ['value'], null)),
          key: get(node, ['uuid'], get(node, ['key'], key)),
          searchField: get(node, ['searchField'], null)
        }

        fields.forEach((field: string) => {
          if (field in node) {
            updatedNode[field] = node[field]
          }
        })

        if (childrenKey in node && childrenKey.length) {
          updatedNode[childrenKey] = convertDataFields(
            node[childrenKey],
            childrenKey,
            fields
          )
        }

        return updatedNode
      })
    : collection

const addAllValue = (
  list: any[] = [],
  convertList = false,
  title = 'All',
  value: number | string = 0
) => [
  {
    key: 0,
    title,
    value,
    children: convertList ? convertDataFields(list) : list
  }
]

export default addAllValue
